import { inject, observer } from 'mobx-react';
import React from 'react';

/**
 * Link component, render only
 */
const Link = inject('ViewStore')(observer(({
                                             ViewStore,
                                             children,
                                             to,
                                             page,
                                             channel,
                                             detail,
                                             options,
                                             className,
                                             style,
                                           }) => (
  <a
    href={'#'}
    className={className}
    style={style}
    onClick={(ev) => {
      // Prevent default behaviour
      ev.preventDefault();

      // Set fallbacks
      to = to || 'start';

      const params = {};
      params.lang  = ViewStore.language;

      if(page) {
        params.page = _.toLower(page);
      }
      if(channel) {
        params.channel = channel;
      }
      if(detail) {
        params.detail = detail;
      }
      // Navigate
      ViewStore.router.navigate(to, params, options);
    }}
  >
    {children}
  </a >
)));

export default Link;



// WEBPACK FOOTER //
// ./src/components/Link/index.js